import {IconMapping} from "../data/IconMappings";
import {BrowserTheme} from "../../services/browser-theme/BrowserTheme";

export function findExistingIcon(): ReadonlyArray<HTMLLinkElement> {

    const iconTest = /\bicon\b/i;

    const linkTags = document.head.getElementsByTagName("link");
    return Array.from(linkTags)
                .filter((tag) => {
                    const rel = tag.getAttribute("rel");
                    return ((rel != null) && iconTest.test(rel));
                });
}

export async function createNotificationFavicon(mapping: IconMapping, theme: BrowserTheme): Promise<string> {
    const source = theme === BrowserTheme.LIGHT ? mapping.lightIcon : mapping.darkIcon;
    const canvas = await loadImage(source);
    drawNotificationIcon(canvas, mapping.color);
    return canvas.toDataURL("image/png");
}

function loadImage(source: string): Promise<HTMLCanvasElement> {
    return new Promise(((resolve, reject) => {
        const img = document.createElement("img");
        img.src = source;
        img.crossOrigin = "anonymous";
        img.onload = () => {
            const canvas = imgToCanvas(img);
            resolve(canvas);
        };
        img.onerror = () => {
            reject(new Error(`Notificon: image not found (${source})`));
        };
    }));
}

function imgToCanvas(img: HTMLImageElement) {
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const context = canvas.getContext("2d")!;
    context.drawImage(img, 0, 0);
    return canvas;
}

function drawNotificationIcon(canvas: HTMLCanvasElement, color: string) {
    const radius = 3;
    const context = canvas.getContext("2d")!;
    context.fillStyle = color;
    const circle = new Path2D();
    circle.arc(canvas.width - radius, canvas.height - radius, radius, 0, 2 * Math.PI);
    context.fill(circle);
}
